

exports.__esModule = true;
exports["default"] = void 0;
var _squid = require("squid");
var _default = exports["default"] = (0, _squid.$registerDirective)('prefix-attrs-with', function () {
  return {
    restrict: 'A',
    link: function link(scope, elem, attrs) {
      var prefix = attrs.prefixAttrsWith;
      if (prefix && prefix.length) {
        ['id', 'for', 'name'].forEach(function (attrName) {
          var base = attrs[attrName];
          if (base) {
            elem.attr(attrName, _squid.$util.dasherizeToCamel(prefix + "-" + base));
          }
        });
      }
    }
  };
});
_squid.$util;
_squid.$registerDirective;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-ui-components/src/prefix-attrs-with/directive.js
// module id = ../node_modules/xo-ui-components/src/prefix-attrs-with/directive.js
// module chunks = 0